<template>
  <div>
    <!-- <h1>{{ chartTitle }}</h1> -->
    <div class="chart_view">
      <chartjs-horizontal-bar :datalabel="dataTitle" :labels="labels" :data="dataset" :backgroundcolor="bkcolor" :bordercolor="bdcolor" :height="700" :option="myOptions" :bind="true" :responsive="true"></chartjs-horizontal-bar>
    </div>
  </div>
</template>

<script>
/**
 * 棒グラフの表示
 * 
 * @vue-data {String} [chartTitle] グラフのタイトル
 * @vue-data {String} [dataTitle] グラフをマウスオーバーで表示される値のチップ内のテキスト（変更できないのでこのまま）
 * @vue-data {Array} [labels] データのラベルテキストの配列
 * @vue-data {Array} [dataset] 値の配列
 * @vue-data {Array} [bkcolor] バーの色
 * @vue-data {Array} [bdcolor] バーの枠の色
 * @vue-data {Object} [myOptions={ legend: { display: false }}] 凡例の非表示オプション
 * @vue-computed {Int} currentQuestionIndex 表示中のお題のインデックス
 * @vue-computed {String} currentGame 表示中のルーレット名
 */

export default {
  name: "ChartView",
  data () {
    return {
      chartTitle: "sample chart",
      dataTitle: "Data",
      labels: ["January", "February", "March", "April", "May", "June", "July"],
      dataset: [65, 59, 70, 81, 56, 55, 40],
      bkcolor: [
        "#c7d5ff",
        "#c7d5ff",
        "#688eff",
        "#c7d5ff",
        "#c7d5ff",
        "#c7d5ff",
        "#c7d5ff"
      ],
      bdcolor: [
        "#c7d5ff",
        "#c7d5ff",
        "#688eff",
        "#c7d5ff",
        "#c7d5ff",
        "#c7d5ff",
        "#c7d5ff"
      ],
      myOptions: { legend: { display: false } }
    }
  },

  computed: {
    worldData () {
      return this.$store.getters.worldData
    },
    japanData () {
      return this.$store.getters.japanData
    },
    questionDataW () {
      return this.$store.getters.questionDataW
    },
    questionDataJ () {
      return this.$store.getters.questionDataJ
    },
    currentQuestionIndex () {
      return this.$store.getters.currentQuestionIndex
    },
    currentGame () {
      return this.$store.getters.currentGame
    }
  },

  created () {
    if (this.currentQuestionIndex >= 0) {
      this.createChartData()
    }
  },

  watch: {
    currentQuestionIndex () {
      // console.log("currentQuestionIndex", this.currentQuestionIndex)
      if (this.currentQuestionIndex >= 0) {
        this.createChartData()
      }
    }
  },

  methods: {
    /**
     * 表示中のお題のデータから棒グラフを作成<br>
     * currentQuestionIndexの変更時に呼ぶ
     */
    createChartData () {
      this.labels.length = 0
      this.dataset.length = 0
      this.bkcolor.length = 0
      this.bdcolor.length = 0

      if (this.currentGame == "worldHard") {
        const cq = this.questionDataW[this.currentQuestionIndex]
        this.chartTitle = cq.title1 + " " + cq.title2
        const attrName = cq.item
        const min = cq.min
        const max = cq.max

        this.worldData.sort(function (a, b) {
          return a[attrName] > b[attrName] ? -1 : 1
        })

        for (let i = 0; i < this.worldData.length; i++) {
          let wd = this.worldData[i]
          this.labels.push(wd.name)
          if (attrName === "population") {
            let val = wd[attrName] * 100
            this.dataset.push(val)
          } else {
            this.dataset.push(wd[attrName])
          }
          if (min <= wd[attrName] && wd[attrName] < max) {
            this.bkcolor.push("#2E446D")
            this.bdcolor.push("#2E446D")
          } else {
            this.bkcolor.push("#B3C3E2")
            this.bdcolor.push("#B3C3E2")
          }
        }
      } else {
        const cq = this.questionDataJ[this.currentQuestionIndex]
        this.chartTitle = cq.title1 + " " + cq.title2
        const attrName = cq.item
        const min = cq.min
        const max = cq.max

        this.japanData.sort(function (a, b) {
          return a[attrName] > b[attrName] ? -1 : 1
        })

        for (let i = 0; i < this.japanData.length; i++) {
          let jd = this.japanData[i]
          this.labels.push(jd.name)
          if (attrName === "population") {
            let val = jd[attrName] / 10
            this.dataset.push(val)
          } else {
            this.dataset.push(jd[attrName])
          }
          if (min <= jd[attrName] && jd[attrName] < max) {
            this.bkcolor.push("#629931")
            this.bdcolor.push("#629931")
          } else {
            this.bkcolor.push("#ABCF8B")
            this.bdcolor.push("#ABCF8B")
          }
        }
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  h1
    font-size: 18px
</style>
